import React, { useRef, useState } from 'react';
import api from '../services/api'; // use your default axios client

export default function ImageUploaderServer({ folder, value, onChange }) {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const pick = () => inputRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!/^image\//.test(file.type)) return alert('Please choose an image.');
    if (file.size > 6 * 1024 * 1024) return alert('Max 6MB.');

    setBusy(true);
    try {
      const form = new FormData();
      form.append('file', file);
      form.append('folder', folder); // e.g. "roster/djs", "roster/influencers", "team"
      const { data } = await api.post('/api/admin/uploads', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onChange(data.publicUrl); // store the public URL in image_url
    } catch (err) {
      console.error(err);
      alert('Upload failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border rounded p-3 space-y-2">
      <button type="button" className="px-3 py-1 border rounded" onClick={pick} disabled={busy}>
        {busy ? 'Uploading…' : 'Upload image'}
      </button>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onFile} />
      {value && <div className="text-xs break-all opacity-70">{value}</div>}
      {value && <img src={value} alt="preview" className="h-24 w-24 object-cover rounded" loading="lazy" />}
    </div>
  );
}
